import HomePage from "@/components/homepage/HomePage.vue";
import ProjectTeam from "@/components/project/ProjectTeam.vue";
import NoteTaking from "@/components/note/NoteTaking.vue";
import ToolTra from "@/components/tool/ToolTra.vue";
import ResourceMain from "@/components/resource/ResourceMain.vue";

const dynamics = [
    {
        path: '/homepage',
        name: 'HomePage',
        component: HomePage,
        meta: {title: '首页', icon: 'home'},
    },
    // {
    //     path: '/projectteam',
    //     name: 'ProjectTeam',
    //     component: ProjectTeam,
    //     meta: {title: '项目', icon: 'home'},
    // },
    // {
    //     path: '/notetaking',
    //     name: 'NoteTaking',
    //     component: NoteTaking,
    //     meta: {title: '笔记', icon: 'home'},
    // },
    // {
    //     path: '/resourcemain',
    //     name: 'ResourceMain',
    //     component: ResourceMain,
    //     meta: {title: '资源', icon: 'home'},
    // },
    {
        path: '/tooltra',
        name: 'ToolTra',
        component: ToolTra,
        meta: {title: '工具', icon: 'home'},
    }
]

export default dynamics;